import { render, staticRenderFns } from "./NivelTecnologico.vue?vue&type=template&id=a53a0c9e"
import script from "./NivelTecnologico.vue?vue&type=script&lang=js"
export * from "./NivelTecnologico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports